<template>
  <form @submit.prevent="addBundleToCart" novalidate>
    <slot></slot>
  </form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "product-bundle-form",
  props: {
    bundletitle: String,
    bundleprice: [Number, String],
  },
  computed: {
    ...mapGetters({
      getProperties: "metafields/getProperties",
    }),
  },
  methods: {
    async addBundleToCart() {
      const checkboxes = document.querySelectorAll(
        "[data-option-radio] .checkbox:checked"
      );
      const selectedVariants = [];
      for (let i = 0; i < checkboxes.length; i++) {
        selectedVariants.push(parseInt(checkboxes[i].dataset.vid));
      }
      const items = selectedVariants.map((variant) => ({
        id: variant,
        properties: this.getProperties(variant),
      }));
      await this.$store.dispatch("cart/addBundleToCart", {
        items,
        bundleProduct: { title: this.bundletitle, price: this.bundleprice },
      });
      await this.$store.dispatch("cart/toggleCart");
    },
  },
};
</script>
